import { render, staticRenderFns } from "./EditTabBusiness.vue?vue&type=template&id=8cd0ff44"
import script from "./EditTabBusiness.vue?vue&type=script&lang=js"
export * from "./EditTabBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports